import { GzLandingPageAppDataProviderFactory } from '../factory/GzLandingPageAppDataProviderFactory';
import { GzLandingPageAppDataProvider } from '../dataProvider/GzLandingPageAppDataProvider';
import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { CardMessage } from '../types';

export class GzLandingPageAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GzLandingPageAppDataProviderFactory;
  public dataProvider: GzLandingPageAppDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GzLandingPageAppDataProviderFactory(),
    });
  }

  public async getGzVersion(): Promise<string | undefined> {
    return this.dataProvider.getGzVersion();
  }

  public async getMessages(): Promise<CardMessage[] | undefined> {
    return this.dataProvider.getCardMessages();
  }

  public async getRssFeedUrls(companyId: string | undefined): Promise<string[] | undefined> {
    return this.dataProvider.getRssFeedUrls(companyId);
  }

  public async getDynamicEventWidgetInfo(companyId: string | undefined): Promise<WidgetInfo> {
    return this.dataProvider.getDynamicEventWidgetInfo(companyId);
  }

  public async getDynamicPromoWidgetInfo(companyId: string | undefined): Promise<WidgetInfo> {
    return this.dataProvider.getDynamicPromoWidgetInfo(companyId);
  }
}
